// extracted by mini-css-extract-plugin
export default {"incodeComponent":"IncodeGlobal__incodeComponent-jXbE"};